// Penyimpanan hasil latihan (riwayat) di bucket R2 binding RIWAYAT.
// Kunci: riwayat/<slug-nama>/<cap-waktu-terbalik>-<acak>.json  (terbaru muncul pertama saat di-list)
export const BATAS_UKURAN = 3 * 1024 * 1024; // 3 MB per hasil latihan
const MAKS_WAKTU = 9999999999999;

export function slugNama(nama) {
  const s = String(nama || '').normalize('NFKD').replace(/[̀-ͯ]/g, '').toLowerCase()
    .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 40);
  return s || 'anonim';
}

export function buatId(sekarang = Date.now()) {
  const acak = [...crypto.getRandomValues(new Uint8Array(4))].map(b => b.toString(16).padStart(2, '0')).join('');
  return String(MAKS_WAKTU - sekarang).padStart(13, '0') + '-' + acak;
}

export const POLA_ID = /^\d{13}-[0-9a-f]{8}$/;
export const POLA_MODUL = /^[a-z0-9-]{1,40}$/;
export const waktuDariId = id => MAKS_WAKTU - Number(String(id).slice(0, 13));
// Kunci per akun (lib/akun.js); akun warisan memakai slug nama sebagai id, jadi kunci lama tetap sama.
export const kunciRiwayat = (akun, id) => `riwayat/${akun}/${id}.json`;

// Validasi bentuk dasar rekaman dari klien. Mengembalikan pesan galat atau null.
export function periksaRekaman(r) {
  if (!r || typeof r !== 'object' || Array.isArray(r)) return 'Data bukan objek.';
  if (typeof r.mapel !== 'string' || !/^[a-z0-9-]{1,40}$/.test(r.mapel)) return 'Field "mapel" tidak valid.';
  if (!Array.isArray(r.soal) || r.soal.length < 1 || r.soal.length > 200) return 'Field "soal" harus berisi 1–200 soal.';
  for (const [i, s] of r.soal.entries()) {
    if (!s || typeof s !== 'object' || !s.q || typeof s.q !== 'object') return `soal[${i}] tidak valid.`;
    if (!['pg', 'bs', 'mcma'].includes(s.q.type)) return `soal[${i}].q.type tidak valid.`;
    if (typeof s.ok !== 'boolean' || typeof s.ms !== 'number') return `soal[${i}] wajib punya ok dan ms.`;
  }
  for (const k of ['nilai', 'benar', 'durasiMs', 'batasLulus']) if (typeof r[k] !== 'number' || !Number.isFinite(r[k])) return `Field "${k}" harus angka.`;
  if (r.nilai < 0 || r.nilai > 100) return 'Field "nilai" harus 0–100.';
  return null;
}

export const ringkasan = r => ({
  nama: String(r.nama).slice(0, 30),
  mapel: r.mapel,
  nilai: String(Math.round(r.nilai)),
  benar: String(r.benar),
  jumlah: String(r.soal.length),
  lulus: r.nilai >= r.batasLulus ? '1' : '0',
  durasiMs: String(Math.round(r.durasiMs)),
  selesai: String(r.selesai || ''),
  // Ronde "Latihan 10 soal topik ini" dari menu belajar: id modulnya.
  ...(typeof r.latihanModul === 'string' && POLA_MODUL.test(r.latihanModul) ? { modul: r.latihanModul } : {}),
});

export const dariMetadata = (id, m = {}) => ({
  id, nama: m.nama || '', mapel: m.mapel || '', nilai: Number(m.nilai), benar: Number(m.benar), jumlah: Number(m.jumlah),
  lulus: m.lulus === '1', durasiMs: Number(m.durasiMs), selesai: m.selesai || '', modul: m.modul || '',
});
